<template>
  <Main>
    <template #default>
      <slot />
    </template>
  </Main>
</template>
